export const defaultState = () => {
  return {
    isOpenUnpublishModal: false,
    unpublishPageType: null,
    disabledConfirm: false,
    choosedPlan: null,
    openBlockModal: false,
    themeId: null,
    pagesPublishCount: {
      publishedPagesCount: 0,
      publishedStaticPagesCount: 0,
      publishedProductPagesCount: 0,
      publishedCollectionPagesCount: 0,
      publishedArticlePagesCount: 0,
      publishedIndexPagesCount: 0,

      maximumPublishedPages: 10,
      maximumPublishedStaticPages: 10,
      maximumPublishedProductPages: 10,
      maximumPublishedCollectionPages: 10,
      maximumPublishedArticlePages: 10
    },
    pages: {
      articlepages: {
        limit: 999999,
        query: "",
        fetched: false,
        list: [],
        unpublishList: [],
        after: null,
        size: 20,
        limited: false
      },
      productpages: {
        limit: 999999,
        query: "",
        fetched: false,
        list: [],
        unpublishList: [],
        after: null,
        size: 20,
        limited: false
      }
    }
  };
};

const state = defaultState();

export default state;
